var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkblueArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66367 8.63003C5.868 8.44428 6.18422 8.45934 6.36997 8.66367L12 14.8567L17.63 8.66367C17.8158 8.45934 18.132 8.44428 18.3363 8.63003C18.5407 8.81579 18.5557 9.13201 18.37 9.33634L12.37 15.9363C12.2752 16.0406 12.1409 16.1 12 16.1C11.8591 16.1 11.7248 16.0406 11.63 15.9363L5.63003 9.33634C5.44428 9.13201 5.45934 8.81579 5.66367 8.63003Z",
    fill: "#4C54A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkblueArrowDown);
export default __webpack_public_path__ + "static/media/darkblue_arrow_down.86868c64c01a01970fe5b3e10ab43f90.svg";
export { ForwardRef as ReactComponent };